import 'projects/sharedComponents/src/feedback/feedbackDialogChip.scss';

import { Checkbox, FormControlLabel } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { AddFeedbackFormInput } from 'projects/sharedComponents/src/feedback/feedbackHooks';
import { FC } from 'react';
import { FeedbackItem } from '@embark/shared-components/src/generated/graphql-client-types';
import { HeapCategory } from 'clientServerShared/types/eventTracking';
import { getHeapDataAttributes } from '@embark/shared-components/src/services/eventTracking/eventTracking';

const feedbackItemToChipText: Record<FeedbackItem, string> = {
  [FeedbackItem.Specific]: 'It was specific to my dog',
  [FeedbackItem.ProductRecommendations]: 'Product recommendations',
  [FeedbackItem.LearnedSomething]: 'I learned something new',
  [FeedbackItem.EasyToUnderstand]: 'Easy to understand',
  [FeedbackItem.WillUse]: 'I will use this information',
  [FeedbackItem.PutAtEase]: 'Put me at ease',
  [FeedbackItem.NotSpecific]: 'Not specific to my dog',
  [FeedbackItem.Advertising]: 'Feels like advertising',
  [FeedbackItem.DidNotLearnAnything]: "I didn't learn anything new",
  [FeedbackItem.TooLong]: 'Too long',
  [FeedbackItem.AlreadyOwn]: 'I already own these products',
  [FeedbackItem.Worried]: 'Makes me worried',
};

type FeedbackDialogChipProps = {
  heapCategory: HeapCategory;
  feedbackItem: FeedbackItem;
};

export const FeedbackDialogChip: FC<FeedbackDialogChipProps> = ({ feedbackItem, heapCategory }) => {
  const { control } = useFormContext<AddFeedbackFormInput>();
  const label = feedbackItemToChipText[feedbackItem];

  return (
    <Controller
      key={feedbackItem}
      name={`selectedFeedback.${feedbackItem}`}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          className={`feedbackDialogChip-label ${!!field.value ? 'checked' : ''}`}
          label={label}
          key={feedbackItem}
          control={
            <Checkbox
              className="feedbackDialogChip-checkbox"
              onChange={(event) => field.onChange(event.target.checked ? feedbackItem : undefined)}
              checked={!!field.value}
              value={feedbackItem}
              {...getHeapDataAttributes({
                heapCategory,
                heapAction: 'Select Feedback Chip',
                heapDetails: feedbackItem,
              })}
            />
          }
        />
      )}
    />
  );
};
